import React from "react";
import { Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import { AiOutlineDownload } from "react-icons/ai";
import resumeFile from "../../Assets/Sai_Tata.docx";

function ResumeNew() {
  return (
    <div>
      <Container fluid className="resume-section">
        <Particle />
        <Row
          style={{
            justifyContent: "center",
            position: "relative",
            paddingTop: "50px",
          }}
        >
          <h1
            className="project-heading"
            style={{ color: "white", paddingBottom: "20px" }}
          >
            My <strong className="purple">Resume</strong>
          </h1>
        </Row>
        <Row
          style={{
            justifyContent: "center",
            position: "relative",
            paddingTop: "20px",
          }}
        >
          <div
            style={{
              textAlign: "center",
              color: "white",
              paddingBottom: "30px",
              maxWidth: "700px",
            }}
          >
            <p style={{ fontSize: "1.2em", marginBottom: "30px" }}>
              Click the button below to download my resume.
            </p>
            <p
              style={{
                fontSize: "1em",
                color: "#c770f0",
                marginBottom: "30px",
              }}
            >
              <strong>Professional Summary:</strong>
            </p>
            <p
              style={{
                fontSize: "0.95em",
                textAlign: "justify",
                lineHeight: "1.8",
                marginBottom: "30px",
              }}
            >
              Generative AI Engineer with 5+ years building backend systems and
              shipping AI-powered features into production at real scale. At
              Kroger (Fortune 25), I build GenAI data pipelines with LangChain
              and OpenAI that plug directly into retail operations. Creator of
              Voycee — a Voice AI platform automating restaurant and hospital
              calls in English and Spanish. Previously built the AI scheduling
              engine at TeamCal AI and worked on high-throughput trading systems
              at DriveWealth. AWS Certified Developer.
            </p>
            <p
              style={{
                fontSize: "0.95em",
                textAlign: "justify",
                lineHeight: "1.8",
                marginBottom: "30px",
              }}
            >
              <strong style={{ color: "#c770f0" }}>Key Experience:</strong>
            </p>
            <ul style={{ textAlign: "left", fontSize: "0.9em", lineHeight: "2" }}>
              <li>
                <strong>Kroger, Fortune 25</strong> (Apr 2025 – Present) –
                Generative AI Engineer, Cincinnati, OH
              </li>
              <li>
                <strong>TeamCal AI</strong> (Apr 2023 – Apr 2025) – Generative
                AI Engineer, Mountain View, CA
              </li>
              <li>
                <strong>DriveWealth</strong> (Jan 2021 – Sep 2022) – Software
                Engineer, Chennai, India
              </li>
              <li>
                <strong>FXMKT Technologies</strong> (Dec 2020 – Jan 2021) –
                Software Developer, Chennai, India
              </li>
            </ul>
            <p
              style={{
                fontSize: "0.95em",
                textAlign: "center",
                lineHeight: "1.8",
                marginTop: "20px",
                marginBottom: "10px",
              }}
            >
              <strong style={{ color: "#c770f0" }}>Certification:</strong> AWS
              Certified Developer – Associate (Valid: Aug 2024 – Aug 2027)
            </p>
          </div>
        </Row>
        <Row
          style={{
            justifyContent: "center",
            position: "relative",
            paddingTop: "20px",
            paddingBottom: "50px",
          }}
        >
          <Button
            variant="primary"
            href={resumeFile}
            download="Sai_Tata_Resume.docx"
            style={{
              maxWidth: "250px",
              fontSize: "1.1em",
              padding: "10px 20px",
            }}
          >
            <AiOutlineDownload />
            &nbsp;Download Resume
          </Button>
        </Row>
      </Container>
    </div>
  );
}

export default ResumeNew;
